import { render, staticRenderFns } from "./JobViewContainer.vue?vue&type=template&id=49acf9a9&lang=pug&"
import script from "./JobViewContainer.vue?vue&type=script&lang=ts&"
export * from "./JobViewContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49acf9a9')) {
      api.createRecord('49acf9a9', component.options)
    } else {
      api.reload('49acf9a9', component.options)
    }
    module.hot.accept("./JobViewContainer.vue?vue&type=template&id=49acf9a9&lang=pug&", function () {
      api.rerender('49acf9a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/job-components/JobViewContainer.vue"
export default component.exports